/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Link } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

const styles = {
  Degree404: css`
    .rc-Degree404 {
      .bt3-container {
        margin-top: 100px;
        margin-bottom: 100px;
        padding-right: 30px;
        padding-left: 30px;
      }
    }
  `,
};
class Degree404 extends React.Component {
  render() {
    return (
      <div className="rc-Degree404" css={styles.Degree404}>
        <div className="bt3-container">
          <h1 className="headline-5-text">{_t('Sorry')}</h1>

          <p className="headline-2-text">
            {_t("We couldn't find the degree that you're looking for.")}

            <span>&nbsp;</span>
            <Link href="/browse">{_t('Browse catalog')}</Link>
          </p>
        </div>
      </div>
    );
  }
}

export default Degree404;
